import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {SearchQuery as ApiSearchQuery} from '../../../api/models/search-query';
import {VaultsService as ApiVaultService} from '../../../api/services/vaults.service';
import {fromEvent, lastValueFrom, takeUntil} from 'rxjs';
import {AuthService} from '../../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class VaultSearchQueriesService {
    private readonly searchQueries: WritableSignal<Array<ApiSearchQuery>> = signal([]);
    private readonly apiVaultService = inject(ApiVaultService);
    private readonly authService = inject(AuthService);

    public async fetchSearchQueriesForVault(vaultId: string, abortSignal?: AbortSignal): Promise<Array<ApiSearchQuery>> {
        const bearer = await this.authService.getBearer();
        const searchQueries$ = this.apiVaultService.VaultsGetVaultSearchQueries({
            vaultId,
            Authorization: bearer
        });
        const searchQueries = await lastValueFrom(
            abortSignal ? searchQueries$.pipe(takeUntil(fromEvent(abortSignal, 'abort'))) : searchQueries$
        );

        this.searchQueries.set(searchQueries);
        return searchQueries;
    }

    public async getOrFetchSearchQueryById(searchQueryId: string, vaultId: string): Promise<ApiSearchQuery | undefined> {
        const searchQuery = this.searchQueries()
            .find(searchQuery => searchQuery.id === searchQueryId);
        if (searchQuery) {
            return searchQuery;
        }

        await this.fetchSearchQueriesForVault(vaultId);
        return this.searchQueries()
            .find(searchQuery => searchQuery.id === searchQueryId);
    }
}
